import React, { useState, useEffect } from 'react';
import { FaEye, FaSearch, FaTrash } from 'react-icons/fa';
import Modal from 'react-bootstrap/Modal';
import { useNavigate } from 'react-router-dom';
import { apiRequestHandler } from '../../apiConfig/service';
import { formatDate } from '../../utils/formatedDate';
import DeleteModal from '../../components/DeleteBlogModal';
import { toast } from 'react-toastify';
import { url } from '../../apiConfig/ApiConfig';
import DataTable from 'react-data-table-component';

const getAllCareer = async (endPoint, token) => {
  const res = await apiRequestHandler({ endPoint, headers: { Authorization: `Bearer ${token}` } });
  return res?.career;
};

const CareerManagement = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [career, setCareer] = useState([]);
  const [filteredCareer, setFilteredCareer] = useState([]);
  const [showViewModal, setShowViewModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedCareer, setSelectedCareer] = useState(null);
  const [careerToDelete, setCareerToDelete] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  const navigate = useNavigate();

  useEffect(() => {
    getAllCareer("allCareer", localStorage.getItem("token")).then((res) => setCareer(res || []));
  }, []);

  useEffect(() => {
    const filtered = career?.filter(
      (career) =>
        career?.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        career?.email?.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredCareer(filtered);
  }, [searchTerm, career]);

  const handleDeleteCareer = async (id) => {
    try {
      setIsLoading(true);
      const res = await apiRequestHandler({
        method: 'DELETE',
        endPoint: `${url}/career/delete/${id}`,
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
      if (res?.success) {
        toast.success(res?.message);
        const updatedCareers = await getAllCareer('allCareer', localStorage.getItem('token'));
        setCareer(updatedCareers || []);
      } else {
        toast.error(res?.message);
      }
    } catch (error) {
      toast.error('Something went wrong');
    } finally {
      setIsLoading(false);
    }
  };

  const handleViewClick = (career) => {
    setSelectedCareer(career);
    setShowViewModal(true);
  };

  const trimText = (text, maxLength = 50) => {
    if (!text) return 'N/A';
    return text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;
  };

  const columns = [
  {
  name: 'Sr No.',
  selector: (row, index) => (currentPage - 1) * 10 + index + 1,
  width: '80px',
}
,
    {
      name: 'Name',
      selector: (row) => trimText(row.name),
      sortable: true,
    },
    {
      name: 'Email',
      selector: (row) => trimText(row.email),
      sortable: true,
    },
    {
      name: 'Job Title',
      selector: (row) => trimText(row.jobTitle),
      sortable: true,
    },
    {
      name: 'Created At',
      selector: (row) => formatDate(row.createdAt),
      sortable: true,
    },
    {
      name: 'Actions',
      cell: (row) => (
        <>
          <FaEye
            title="View"
            style={{ color: '#064a8c', marginRight: '10px', cursor: 'pointer' }}
            onClick={() => handleViewClick(row)}
          />
          <FaTrash
            title="Delete"
            style={{ color: '#f44336', cursor: 'pointer' }}
            onClick={() => {
              setCareerToDelete(row);
              setShowDeleteModal(true);
            }}
          />
        </>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  return (
    <div style={{ minHeight: '100vh', padding: '20px', background: '#f5f7fa' }}>
      <div style={{ padding: '0px', borderRadius: '10px' }}>
        <div style={{ backgroundColor: "#fff", padding: "20px", borderRadius: "10px" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",

              flexWrap: "wrap",
              marginBottom: "20px",
            }}
          >
            <h4 style={{ margin: 0 }}>Career Management</h4>
          </div>
        </div>

        <DeleteModal
          show={showDeleteModal}
          onClose={() => setShowDeleteModal(false)}
          onConfirm={() => {
            handleDeleteCareer(careerToDelete?._id);
            setShowDeleteModal(false);
          }}
        />

        <div className='modifyTable' style={{ borderRadius: '10px', marginTop: '20px' }}>
          <DataTable
            columns={columns}
            data={filteredCareer}
            pagination
            highlightOnHover
            striped
            progressPending={isLoading}
            subHeader
            responsive
            paginationDefaultPage={currentPage}
            onChangePage={(page) => setCurrentPage(page)}
            subHeaderComponent={
              <input
                type="text"
                placeholder="Search by name or email..."
                value={searchTerm}
                onChange={(e) => {
                  setSearchTerm(e.target.value);
                  setCurrentPage(1); // reset to first page on new search
                }}
                style={{
                  padding: '8px 12px',
                  borderRadius: '6px',
                  border: '1px solid #ddd',
                  fontSize: '14px',
                  width: '250px',
                }}
              />
            }
          />

        </div>
      </div>

      <Modal show={showViewModal} onHide={() => setShowViewModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Contact Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedCareer && (
            <div className="row">
              <div className="col-lg-6">
                <strong>Name:</strong>
                <div>{selectedCareer?.name || 'N/A'}</div>
              </div>
              <div className="col-lg-6">
                <strong>Email:</strong>
                <div>{selectedCareer?.email || 'N/A'}</div>
              </div>
              <div className="col-lg-6">
                <strong>Mobile:</strong>
                <div>{selectedCareer?.mobile || 'N/A'}</div>
              </div>
              <div className="col-lg-6">
                <strong>Job Title:</strong>
                <div>{selectedCareer?.jobTitle || 'N/A'}</div>
              </div>
              <div className="col-lg-12">
                <strong>Cover Letter:</strong>
                <div>{selectedCareer?.coverLetter || 'N/A'}</div>
              </div>
              <div className="col-lg-6">
                <strong>Created At:</strong>
                <div>{selectedCareer?.createdAt || 'N/A'}</div>
              </div>
              <div className="col-lg-6">
                <strong>Resume:</strong>
                <button
                  onClick={() => window.open(selectedCareer.file)}
                  style={{
                             background: "linear-gradient(to bottom right, #163252, #0081ff)",

                    color: '#fff',
                    border: 'none',
                    padding: '4px 12px',
                    borderRadius: '5px',
                    cursor: 'pointer',
                    fontSize: '14px',
                    marginTop: '5px',
                  }}
                >
                  View
                </button>
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button
            style={{
                           background: "linear-gradient(to bottom right, #163252, #0081ff)",
              color: '#fff',
              border: 'none',
              padding: '8px 16px',
              borderRadius: '5px',
              cursor: 'pointer',
              fontSize: '14px',
            }}
            onClick={() => setShowViewModal(false)}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default CareerManagement;